module.exports = __webpack_public_path__ + "img/39@2x.0c9572f2.png";